import { render } from "./CarouselServicios.vue?vue&type=template&id=1efcaa74"
import script from "./CarouselServicios.vue?vue&type=script&lang=js"
export * from "./CarouselServicios.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__